module.exports = __webpack_public_path__ + "img/公司简介.14d7d4e8.jpg";